module.exports = __webpack_public_path__ + "img/03.5392ae15.jpg";